/**
 * axios setup to use mock service
 */

import axios from 'axios';
import { TokenService } from './token.service';
import { urlProvider } from '../url/UrlProviderInstanceManager';

const axiosForLink = axios.create({
    baseURL: urlProvider.getApUrl(),
    withCredentials: true
});

// interceptor for http
axiosForLink.interceptors.request.use(
    (config) => {
        let accessToken = TokenService.getInstance().getAuthLinkToken();
        if (config.headers)
            config.headers['Authorization'] = `Bearer ${accessToken}`;

        return config;
    },
    (error) => Promise.reject((error.response && error.response.data) || 'Wrong Services')
);

export default axiosForLink;